/**
* This is a higher order component to include all common components.
* We are including footer as a common component since we do not want it to
* show up when the component is still loading. It is a very jarring experience
* to have footer component show up at the top of the page a few milliseconds before component loads.
* Any common components that have the same characteristics as footer can be added here
**/

import React from 'react'
import Footer from 'scripts/components/static/footer'
import SsrContext from 'scripts/components/base/SsrContext'

export default function SoompiCommon(Component) {
  return class CommonComponent extends React.Component {
    render() {
      return (
        <React.Fragment>
          <Component {...this.props} />
          <SsrContext.Consumer>
            {({ssr}) => (
              <Footer ssr={ssr} {...this.props} />
            )}
          </SsrContext.Consumer>
        </React.Fragment>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/SoompiCommon.jsx